exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stats{width:100%;max-width:400px;margin:110px auto;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column;text-align:center}.stats p{text-transform:uppercase;margin:0;padding:0;opacity:0.8;max-width:300px}.stats h1{color:#143c3a;margin:0;padding:0;font-size:4em}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/Stats/Stats.scss
// module id = 303
// module chunks = 0